import * as React from 'react';
import { Link } from 'react-router-dom';

import { addModifiers } from '../../shared/helpers';

import './Card.scss';
import classcat from 'classcat';

interface CardProps {
  title?: string;
  children: JSX.Element[] | JSX.Element;
  headerRightElem?: JSX.Element[] | JSX.Element | null;
  hasFooter?: boolean;
  hasHeader?: boolean;
  headerLink?: string;
  footerLink?: string;
  contentFull?: boolean;
  headerLinkLabel?: string;
  footerLinkLabel?: string;
  footerLinkModifiers?: string[];
  modifiers?: string[];
  modifiersHeaderLink?: string[];
  modifiersTitle?: string[];
  modifiersContent?: string[];
  hasHeaderButton?: boolean;
  headerButtonLabel?: string;
  handleHeaderButton?: (e: any) => void;
  messageId?: string;
  addAlphaIcon?: boolean;
  wrapperClassName?: string;
  onHeaderLinkClick?: () => void;
}

const Card = ({
  children,
  title,
  headerLink,
  headerLinkLabel,
  headerRightElem,
  footerLink,
  hasHeaderButton,
  headerButtonLabel,
  handleHeaderButton,
  modifiers = [],
  modifiersHeaderLink = [],
  footerLinkModifiers = [],
  modifiersTitle = [],
  modifiersContent = [],
  contentFull = false,
  footerLinkLabel,
  hasHeader = true,
  hasFooter = false,
  addAlphaIcon = false,
  messageId = '',
  wrapperClassName,
  onHeaderLinkClick,
}: CardProps): JSX.Element => (
  <article className={addModifiers('card', modifiers)}>
    <div className={classcat(['card__wrapper', wrapperClassName])}>
      {hasHeader && (
        <header className="card__header">
          {title && (
            <h2 className={addModifiers('card__header-title', modifiersTitle)}>
              {addAlphaIcon && <span className="alphas__title-icon">α</span>}
              {title}
            </h2>
          )}
          {headerRightElem && <div className="card__header-elem">{headerRightElem}</div>}
          {headerLink && headerLinkLabel && (
            <Link to={headerLink} className={addModifiers('card__header-link', modifiersHeaderLink)} onClick={onHeaderLinkClick}>
              {headerLinkLabel}
            </Link>
          )}
          {hasHeaderButton && (
            <div id={messageId} className={addModifiers('card__header-link', modifiersHeaderLink)} onClick={handleHeaderButton}>
              {headerButtonLabel}
            </div>
          )}
        </header>
      )}

      <div
        className={
          contentFull === true
            ? addModifiers('card__content', modifiersContent.concat(['full']))
            : addModifiers('card__content', modifiersContent)
        }
      >
        {children}
      </div>

      {hasFooter && (
        <footer className="card__footer">
          {footerLink && footerLinkLabel && (
            <a href={footerLink} className={addModifiers('card__footer-title', footerLinkModifiers)}>
              {footerLinkLabel}
            </a>
          )}
        </footer>
      )}
    </div>
  </article>
);

export default Card;
